export const isrTabs = [
  { title: "ISR details", id: "isr_details", active: true },
  { title: "Attachments", id: "isr_attachments" },
  { title: "Emails", id: "isr_emails" },
];

export const createIsrFormData = (countryList) => {
  return [
    {
      id: 1,
      title: "",
      formStyle: {
        columnGap: "2.7%",
      },
      fieldStyle: {
        flex: "0 31.3%",
      },
      formFields: [
        {
          id: "requestor_dept",
          label: "Requestor Dept",
          placeholder: "Requestor Dept",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Requestor Dept",
              label: "Select Requestor Dept",
              value: "",
            },
            {
              id: 2,
              displayName: "Single Carrier",
              label: "Single Carrier",
              value: "Single Carrier",
            },
            {
              id: 3,
              displayName: "Multi-Carrier",
              label: "Multi-Carrier",
              value: "Multi-Carrier",
            },
          ],
          required: true,
          name: "requestor_dept",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "status",
          label: "Status",
          placeholder: "Status",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Status",
              label: "Select Status",
              value: "",
            },
            {
              id: 2,
              displayName: "New",
              label: "New",
              value: "New",
            },
            {
              id: 3,
              displayName: "In Progress",
              label: "In Progress",
              value: "In Progress",
            },
            {
              id: 4,
              displayName: "Closed - Resolved",
              label: "Closed - Resolved",
              value: "Closed - Resolved",
            },
            {
              id: 5,
              displayName: "Closed - Merged",
              label: "Closed - Merged",
              value: "Closed - Merged",
            },
            {
              id: 6,
              displayName: "Closed - Duplicate",
              label: "Closed - Duplicate",
              value: "Closed - Duplicate",
            },
          ],
          required: true,
          name: "status",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "account_name",
          label: "Account Name",
          placeholder: "Provide Account Name",
          type: "input",
          name: "account_name",
        },
        {
          id: "contact_name",
          label: "Contact Name",
          placeholder: "Provide Contact Name",
          type: "input",
          name: "contact_name",
          visible: () => true,
          disabled: () => true,
        },
        {
          id: "direction",
          label: "Direction",
          placeholder: "Direction",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Direction",
              label: "Select Direction",
              value: "",
            },
            {
              id: 2,
              displayName: "Export",
              label: "Export",
              value: "Export",
            },
            {
              id: 3,
              displayName: "Import",
              label: "Import",
              value: "Import",
            },
            {
              id: 4,
              displayName: "Domestic",
              label: "Domestic",
              value: "Domestic",
            },
          ],
          required: true,
          name: "direction",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "liner_brand",
          label: "Brand",
          placeholder: "Brand",
          type: "select",
          required: true,
          options: [
            {
              id: 1,
              displayName: "Select Brand",
              label: "Select Brand",
              value: "",
            },
            {
              id: 2,
              displayName: "Maersk Line",
              label: "Maersk Line",
              value: "Maersk Line",
            },
            {
              id: 3,
              displayName: "Safmarine",
              label: "Safmarine",
              value: "Safmarine",
            },
            {
              id: 4,
              displayName: "Sealand",
              label: "Sealand",
              value: "Sealand",
            },
            {
              id: 5,
              displayName: "MCC",
              label: "MCC",
              value: "MCC",
            },
            {
              id: 6,
              displayName: "Seago",
              label: "Seago",
              value: "Seago",
            },
            {
              id: 7,
              displayName: "Maersk L&S",
              label: "Maersk L&S",
              value: "Maersk L&S",
            },
          ],
          name: "liner_brand",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "country",
          label: "Country",
          placeholder: "Search Country",
          type: "searchDropdown",
          dropdownLabel: "value",
          options: countryList || [],
          required: true,
          loading: false,
          name: "country",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "mll",
          label: "MLL",
          placeholder: "",
          type: "checkbox",
          name: "mll",
        },
        {
          id: "loc",
          label: "Loc",
          placeholder: "Loc",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Loc",
              label: "Select Loc",
              value: "",
            },
            {
              id: 2,
              displayName: "Africa",
              label: "Africa",
              value: "Africa",
            },
            {
              id: 3,
              displayName: "Asia Pacific",
              label: "Asia Pacific",
              value: "Asia Pacific",
            },
            {
              id: 4,
              displayName: "Far East Asia",
              label: "Far East Asia",
              value: "Far East Asia",
            },
            {
              id: 5,
              displayName: "Latin America",
              label: "Latin America",
              value: "Latin America",
            },
            {
              id: 6,
              displayName: "North America",
              label: "North America",
              value: "North America",
            },
            {
              id: 7,
              displayName: "North Europe",
              label: "North Europe",
              value: "North Europe",
            },
            {
              id: 8,
              displayName: "South Europe",
              label: "South Europe",
              value: "South Europe",
            },
            {
              id: 9,
              displayName: "West Central Asia",
              label: "West Central Asia",
              value: "West Central Asia",
            },
            {
              id: 10,
              displayName: "MCC",
              label: "MCC",
              value: "MCC",
            },
            {
              id: 11,
              displayName: "Sealand",
              label: "Sealand",
              value: "Sealand",
            },
            {
              id: 12,
              displayName: "Seago",
              label: "Seago",
              value: "Seago",
            },
          ],
          name: "loc",
          required: (formState) =>
            formState?.resolver_dept === "Ocean: Operations - Ocean",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState?.resolver_dept === "Ocean: Operations - Ocean" &&
                !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
        {
          id: "cluster_csce",
          label: "Cluster CS/CE",
          placeholder: "Cluster CS/CE",
          type: "checkbox",
          name: "cluster_csce",
        },
        {
          id: "resolver_dept",
          label: "Resolver Dept",
          placeholder: "Resolver Dept",
          type: "select",
          options: [
            {
              id: 0,
              displayName: "Select Resolver Dept",
              label: "Select Resolver Dept",
              value: "",
            },
            {
              id: 1,
              displayName: "Ocean: Customer Service",
              label: "Ocean: Customer Service",
              value: "Ocean: Customer Service",
            },
            {
              id: 2,
              displayName: "Ocean: Customer Service - Export Doc",
              label: "Ocean: Customer Service - Export Doc",
              value: "Ocean: Customer Service - Export Doc",
            },
            {
              id: 3,
              displayName: "Ocean: Customer Service - Import Doc",
              label: "Ocean: Customer Service - Import Doc",
              value: "Ocean: Customer Service - Import Doc",
            },
            {
              id: 4,
              displayName: "Ocean: Customer Service - SEM (Task Closure)",
              label: "Ocean: Customer Service - SEM (Task Closure)",
              value: "Ocean: Customer Service - SEM (Task Closure)",
            },
            {
              id: 5,
              displayName: "Ocean: Finance - AFR Team",
              label: "Ocean: Finance - AFR Team",
              value: "Ocean: Finance - AFR Team",
            },
            {
              id: 6,
              displayName: "Ocean: Legal",
              label: "Ocean: Legal",
              value: "Ocean: Legal",
            },
            {
              id: 7,
              displayName: "Ocean: Operations - Inland",
              label: "Ocean: Operations - Inland",
              value: "Ocean: Operations - Inland",
            },
            {
              id: 8,
              displayName: "Ocean: Operations - Ocean",
              label: "Ocean: Operations - Ocean",
              value: "Ocean: Operations - Ocean",
            },
            {
              id: 9,
              displayName: "Ocean: Operations - Reefer",
              label: "Ocean: Operations - Reefer",
              value: "Ocean: Operations - Reefer",
            },
            {
              id: 10,
              displayName: "Ocean: Sales",
              label: "Ocean: Sales",
              value: "Ocean: Sales",
            },
            {
              id: 11,
              displayName: "Ocean: Sales - DnD",
              label: "Ocean: Sales - DnD",
              value: "Ocean: Sales - DnD",
            },
            {
              id: 12,
              displayName: "MC CX: CHB",
              label: "MC CX: CHB",
              value: "MC CX: CHB",
            },
            {
              id: 13,
              displayName: "MC CX: Landside Transportation",
              label: "MC CX: Landside Transportation",
              value: "MC CX: Landside Transportation",
            },
            {
              id: 14,
              displayName: "MC CX: LCL",
              label: "MC CX: LCL",
              value: "MC CX: LCL",
            },
            {
              id: 15,
              displayName: "MC Execution: CHB",
              label: "MC Execution: CHB",
              value: "MC Execution: CHB",
            },
            {
              id: 16,
              displayName: "MC Execution: Landside Transportation",
              label: "MC Execution: Landside Transportation",
              value: "MC Execution: Landside Transportation",
            },
            {
              id: 17,
              displayName: "MC Execution: LCL",
              label: "MC Execution: LCL",
              value: "MC Execution: LCL",
            },
            {
              id: 18,
              displayName: "MC: Legal",
              label: "MC: Legal",
              value: "MC: Legal",
            },
            {
              id: 19,
              displayName: "SCM: Customer Service",
              label: "SCM: Customer Service",
              value: "SCM: Customer Service",
            },
            {
              id: 20,
              displayName: "SCM: FINOPS",
              label: "SCM: FINOPS",
              value: "SCM: FINOPS",
            },
          ],
          required: true,
          name: "resolver_dept",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "collaboration_reason",
          label: "Collaboration Reason",
          placeholder: "Collaboration Reason",
          type: "select",
          options: (formState) =>
            formState.resolver_dept
              ? resolverDeptCollaborationReasonMapping[formState.resolver_dept]
              : [
                  {
                    id: 0,
                    displayName: "Select Collaboration Reason",
                    label: "Select Collaboration Reason",
                    value: "",
                  },
                ],
          required: (formState) => formState.resolver_dept !== "SCM: FINOPS",
          name: "collaboration_reason",
          disabled: (formState) =>
            !formState.resolver_dept ||
            formState.resolver_dept === "SCM: FINOPS",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState.resolver_dept === "SCM: FINOPS"
                  ? false
                  : !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
        {
          id: "collaboration_reason_other",
          label: "Collaboration Reason Other",
          placeholder: "Provide Collaboration Reason Other",
          type: "input",
          name: "collaboration_reason_other",
          visible: (formState) => formState.collaboration_reason === "Other",
          required: (formState) => formState.collaboration_reason === "Other",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState.collaboration_reason === "Other" && !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
        {
          id: "subject",
          label: "Subject",
          placeholder: "Provide Subject",
          type: "input",
          name: "subject",
          required: true,
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "description",
          label: "Description",
          placeholder: "Provide Description",
          type: "textarea",
          name: "description",
          required: true,
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "resolution_summary",
          label: "Resolution Summary",
          placeholder: "Provide Resolution Summary",
          type: "textarea",
          name: "resolution_summary",
          required: (formState) => formState?.status === "Closed - Resolved",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState?.status === "Closed - Resolved" && !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
        {
          id: "bol_number",
          label: "BoL Number",
          placeholder: "Provide BoL Number",
          type: "input",
          name: "bol_number",
          visible: () => true,
          disabled: () => false,
          required: (formState) =>
            formState.liner_brand !== "Maersk L&S" &&
            formState.collaboration_reason === "AFR Closure",
          validation: {
            customValidation: (value, field, formState) => {
              if (value && (value || "").toString().trim().length !== 9) {
                return {
                  isError: true,
                  errorMessage:
                    "BOL number should be alphanumeric with 9 characters",
                };
              } else if (
                formState.liner_brand !== "Maersk L&S" &&
                formState.collaboration_reason === "AFR Closure" &&
                !value
              ) {
                return {
                  isError: true,
                  errorMessage: "Please provide Bill of Lading Number.",
                };
              }
            },
          },
        },
      ],
    },
  ];
};

export const isrDetailsForm = (
  countryList,
  cityList,
  ownerId = "",
  subType
) => {
  return [
    {
      id: 1,
      title: "Basic Information",
      formStyle: {
        columnGap: "2.7%",
      },
      fieldStyle: {
        flex: "0 31.5%",
      },
      formFields: [
        {
          id: "case_number",
          label: "Case Number",
          placeholder: "Case Number",
          type: "input",
          name: "case_number",
          disabled: () => true,
        },
        {
          id: "case_owner",
          label: "Case owner",
          placeholder: "Case owner",
          type: "input",
          name: "owner_name",
          disabled: () => true,
        },
        {
          id: "requestor_dept",
          label: "Requestor Dept",
          placeholder: "Requestor Dept",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Requestor Dept",
              label: "Select Requestor Dept",
              value: "",
            },
            {
              id: 2,
              displayName: "Single Carrier",
              label: "Single Carrier",
              value: "Single Carrier",
            },
            {
              id: 3,
              displayName: "Multi-Carrier",
              label: "Multi-Carrier",
              value: "Multi-Carrier",
            },
          ],
          required: true,
          name: "requestor_dept",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "case_record_type",
          label: "Case Record Type",
          placeholder: "Case Record Type",
          type: "input",
          name: "case_record_type",
          disabled: () => true,
        },
        {
          id: "delivery_channel",
          label: "Delivery Channel",
          placeholder: "Delivery Channel",
          type: "select",
          name: "delivery_channel",
          options: [
            {
              id: 0,
              displayName: "Select Delivery Channel",
              label: "Select Delivery Channel",
              value: "",
            },
            {
              id: 1,
              displayName: "Spot",
              label: "Spot",
              value: "Spot",
            },
            {
              id: 1,
              displayName: "Twill",
              label: "Twill",
              value: "Twill",
            },
            {
              id: 3,
              displayName: "Booking Services (BKS)",
              label: "Booking Services (BKS)",
              value: "Booking Services (BKS)",
            },
          ],
          disabled: () => false,
        },
        {
          id: "status",
          label: "Status",
          placeholder: "Status",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Status",
              label: "Select Status",
              value: "",
            },
            {
              id: 2,
              displayName: "New",
              label: "New",
              value: "New",
            },
            {
              id: 3,
              displayName: "In Progress",
              label: "In Progress",
              value: "In Progress",
            },
            {
              id: 4,
              displayName: "Closed - Resolved",
              label: "Closed - Resolved",
              value: "Closed - Resolved",
            },
            {
              id: 5,
              displayName: "Closed - Merged",
              label: "Closed - Merged",
              value: "Closed - Merged",
            },
            {
              id: 6,
              displayName: "Closed - Duplicate",
              label: "Closed - Duplicate",
              value: "Closed - Duplicate",
            },
          ],
          name: "status",
          required: true,
          validation: {
            rules: ["required"],
            customValidation: (value) => ({
              isError:
                ownerId.slice(0, 3) === "00G" &&
                subType !== "Spam/Case Created in Error" &&
                (value === "Closed - Resolved" ||
                  value === "Closed - Merged" ||
                  value === "Closed - Duplicate")
                  ? true
                  : false,
              errorMessage: "The Case cannot be closed if the owner is a Queue",
            }),
          },
        },
        {
          id: "account_name",
          label: "Account Name",
          placeholder: "Provide Account Name",
          type: "input",
          name: "account_name",
          disabled: () => true,
        },
        {
          id: "contact_name",
          label: "Contact Name",
          placeholder: "Provide Contact Name",
          type: "input",
          name: "contact_name",
          visible: () => true,
          disabled: () => true,
        },
        {
          id: "direction",
          label: "Direction",
          placeholder: "Direction",
          type: "select",
          name: "direction",
          options: [
            {
              id: 1,
              displayName: "Select Direction",
              label: "Select Direction",
              value: "",
            },
            {
              id: 2,
              displayName: "Export",
              label: "Export",
              value: "Export",
            },
            {
              id: 3,
              displayName: "Import",
              label: "Import",
              value: "Import",
            },
            {
              id: 4,
              displayName: "Domestic",
              label: "Domestic",
              value: "Domestic",
            },
          ],
          required: true,
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "liner_brand",
          label: "Brand",
          placeholder: "Brand",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Brand",
              label: "Select Brand",
              value: "",
            },
            {
              id: 2,
              displayName: "Maersk Line",
              label: "Maersk Line",
              value: "Maersk Line",
            },
            {
              id: 3,
              displayName: "Safmarine",
              label: "Safmarine",
              value: "Safmarine",
            },
            {
              id: 4,
              displayName: "Sealand",
              label: "Sealand",
              value: "Sealand",
            },
            {
              id: 5,
              displayName: "MCC",
              label: "MCC",
              value: "MCC",
            },
            {
              id: 6,
              displayName: "Seago",
              label: "Seago",
              value: "Seago",
            },
            {
              id: 7,
              displayName: "Maersk L&S",
              label: "Maersk L&S",
              value: "Maersk L&S",
            },
          ],
          name: "liner_brand",
          required: true,
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "contact_phone",
          label: "Contact Phone",
          placeholder: "Provide Contact Phone",
          type: "input",
          name: "contact_phone",
          disabled: true,
        },
        {
          id: "mll",
          label: "MLL",
          placeholder: "",
          type: "checkbox",
          name: "mll",
        },
        {
          id: "priority",
          label: "Priority",
          placeholder: "Priority",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Priority",
              label: "Select Priority",
              value: "",
            },
            {
              id: 2,
              displayName: "High",
              label: "High",
              value: "High",
            },
            {
              id: 3,
              displayName: "Medium",
              label: "Medium",
              value: "Medium",
            },
            {
              id: 4,
              displayName: "Low",
              label: "Low",
              value: "Low",
            },
          ],
          name: "priority",
        },
        {
          id: "response_received_flag",
          label: "Response Received Flag",
          type: "checkbox",
          name: "response_received",
        },
        {
          id: "resolver_dept",
          label: "Resolver Dept",
          placeholder: "Resolver Dept",
          type: "select",
          options: [
            {
              id: 0,
              displayName: "Select Resolver Dept",
              label: "Select Resolver Dept",
              value: "",
            },
            {
              id: 1,
              displayName: "Ocean: Customer Service",
              label: "Ocean: Customer Service",
              value: "Ocean: Customer Service",
            },
            {
              id: 2,
              displayName: "Ocean: Customer Service - Export Doc",
              label: "Ocean: Customer Service - Export Doc",
              value: "Ocean: Customer Service - Export Doc",
            },
            {
              id: 3,
              displayName: "Ocean: Customer Service - Import Doc",
              label: "Ocean: Customer Service - Import Doc",
              value: "Ocean: Customer Service - Import Doc",
            },
            {
              id: 4,
              displayName: "Ocean: Customer Service - SEM (Task Closure)",
              label: "Ocean: Customer Service - SEM (Task Closure)",
              value: "Ocean: Customer Service - SEM (Task Closure)",
            },
            {
              id: 5,
              displayName: "Ocean: Finance - AFR Team",
              label: "Ocean: Finance - AFR Team",
              value: "Ocean: Finance - AFR Team",
            },
            {
              id: 6,
              displayName: "Ocean: Legal",
              label: "Ocean: Legal",
              value: "Ocean: Legal",
            },
            {
              id: 7,
              displayName: "Ocean: Operations - Inland",
              label: "Ocean: Operations - Inland",
              value: "Ocean: Operations - Inland",
            },
            {
              id: 8,
              displayName: "Ocean: Operations - Ocean",
              label: "Ocean: Operations - Ocean",
              value: "Ocean: Operations - Ocean",
            },
            {
              id: 9,
              displayName: "Ocean: Operations - Reefer",
              label: "Ocean: Operations - Reefer",
              value: "Ocean: Operations - Reefer",
            },
            {
              id: 10,
              displayName: "Ocean: Sales",
              label: "Ocean: Sales",
              value: "Ocean: Sales",
            },
            {
              id: 11,
              displayName: "Ocean: Sales - DnD",
              label: "Ocean: Sales - DnD",
              value: "Ocean: Sales - DnD",
            },
            {
              id: 12,
              displayName: "MC CX: CHB",
              label: "MC CX: CHB",
              value: "MC CX: CHB",
            },
            {
              id: 13,
              displayName: "MC CX: Landside Transportation",
              label: "MC CX: Landside Transportation",
              value: "MC CX: Landside Transportation",
            },
            {
              id: 14,
              displayName: "MC CX: LCL",
              label: "MC CX: LCL",
              value: "MC CX: LCL",
            },
            {
              id: 15,
              displayName: "MC Execution: CHB",
              label: "MC Execution: CHB",
              value: "MC Execution: CHB",
            },
            {
              id: 16,
              displayName: "MC Execution: Landside Transportation",
              label: "MC Execution: Landside Transportation",
              value: "MC Execution: Landside Transportation",
            },
            {
              id: 17,
              displayName: "MC Execution: LCL",
              label: "MC Execution: LCL",
              value: "MC Execution: LCL",
            },
            {
              id: 18,
              displayName: "MC: Legal",
              label: "MC: Legal",
              value: "MC: Legal",
            },
            {
              id: 19,
              displayName: "SCM: Customer Service",
              label: "SCM: Customer Service",
              value: "SCM: Customer Service",
            },
            {
              id: 20,
              displayName: "SCM: FINOPS",
              label: "SCM: FINOPS",
              value: "SCM: FINOPS",
            },
          ],
          name: "resolver_dept",
          required: true,
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "collaboration_reason",
          label: "Collaboration Reason",
          placeholder: "Collaboration Reason",
          type: "select",
          options: (formState) =>
            resolverDeptCollaborationReasonMapping[formState.resolver_dept],
          required: (formState) => formState.resolver_dept !== "SCM: FINOPS",
          name: "collaboration_reason",
          disabled: (formState) =>
            !formState.resolver_dept ||
            formState.resolver_dept === "SCM: FINOPS",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState.resolver_dept === "SCM: FINOPS"
                  ? false
                  : !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
        {
          id: "collaboration_reason_other",
          label: "Collaboration Reason Other",
          placeholder: "Provide Collaboration Reason Other",
          type: "input",
          name: "collaboration_reason_other",
          visible: (formState) => formState.collaboration_reason === "Other",
          required: (formState) => formState.collaboration_reason === "Other",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState.collaboration_reason === "Other" && !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
        {
          id: "cluster_CS/CE",
          label: "Cluster CS/CE",
          type: "checkbox",
          name: "cluster_csce",
        },
        {
          id: "bol_number",
          label: "BoL Number",
          placeholder: "Provide BoL Number",
          type: "input",
          name: "bol_number",
          visible: () => true,
          disabled: () => false,
          required: (formState) =>
            formState.liner_brand !== "Maersk L&S" &&
            formState.collaboration_reason === "AFR Closure",
          validation: {
            customValidation: (value, field, formState) => {
              if (value && (value || "").toString().trim().length !== 9) {
                return {
                  isError: true,
                  errorMessage:
                    "BOL number should be alphanumeric with 9 characters",
                };
              } else if (
                formState.liner_brand !== "Maersk L&S" &&
                formState.collaboration_reason === "AFR Closure" &&
                !value
              ) {
                return {
                  isError: true,
                  errorMessage: "Please provide Bill of Lading Number.",
                };
              }
            },
          },
        },
        {
          id: "parent_case_number",
          label: "Parent Case",
          placeholder: "Provide Parent Case",
          type: "input",
          name: "parent_case_number",
        },
      ],
    },
    {
      id: 2,
      title: "Additional information",
      formStyle: {
        columnGap: "2.7%",
      },
      fieldStyle: {
        flex: "0 48.3%",
      },
      formFields: [
        {
          id: "Subject",
          label: "Subject",
          placeholder: "Provide Subject",
          type: "input",
          name: "subject",
          required: true,
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "Description",
          label: "Description",
          placeholder: "Provide Description",
          type: "textarea",
          name: "description",
          required: true,
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "resolution_summary",
          label: "Resolution Summary",
          placeholder: "Provide Resolution Summary",
          type: "textarea",
          name: "resolution_summary",
          required: (formState) => formState?.status === "Closed - Resolved",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState?.status === "Closed - Resolved" && !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
      ],
    },
    {
      id: 3,
      title: "Geography Information",
      formStyle: {
        columnGap: "2.7%",
      },
      fieldStyle: {
        flex: "0 31.5%",
      },
      formFields: [
        {
          id: "country",
          label: "Country",
          placeholder: "Search Country",
          type: "searchDropdown",
          dropdownLabel: "value",
          options: countryList ? countryList : [],
          required: true,
          name: "country",
          validation: {
            rules: ["required"],
          },
        },
        {
          id: "city",
          label: "City",
          placeholder: "Search City",
          dropdownLabel: "value",
          type: "searchDropdown",
          options: cityList ? cityList : [],
          name: "city",
        },
        {
          id: "loc",
          label: "Loc",
          placeholder: "Loc",
          type: "select",
          options: [
            {
              id: 1,
              displayName: "Select Loc",
              label: "Select Loc",
              value: "",
            },
            {
              id: 2,
              displayName: "Africa",
              label: "Africa",
              value: "Africa",
            },
            {
              id: 3,
              displayName: "Asia Pacific",
              label: "Asia Pacific",
              value: "Asia Pacific",
            },
            {
              id: 4,
              displayName: "Far East Asia",
              label: "Far East Asia",
              value: "Far East Asia",
            },
            {
              id: 5,
              displayName: "Latin America",
              label: "Latin America",
              value: "Latin America",
            },
            {
              id: 6,
              displayName: "North America",
              label: "North America",
              value: "North America",
            },
            {
              id: 7,
              displayName: "North Europe",
              label: "North Europe",
              value: "North Europe",
            },
            {
              id: 8,
              displayName: "South Europe",
              label: "South Europe",
              value: "South Europe",
            },
            {
              id: 9,
              displayName: "West Central Asia",
              label: "West Central Asia",
              value: "West Central Asia",
            },
            {
              id: 10,
              displayName: "MCC",
              label: "MCC",
              value: "MCC",
            },
            {
              id: 11,
              displayName: "Sealand",
              label: "Sealand",
              value: "Sealand",
            },
            {
              id: 12,
              displayName: "Seago",
              label: "Seago",
              value: "Seago",
            },
          ],
          name: "loc",
          required: (formState) =>
            formState?.resolver_dept === "Ocean: Operations - Ocean",
          validation: {
            customValidation: (value, field, formState) => ({
              isError:
                formState?.resolver_dept === "Ocean: Operations - Ocean" &&
                !value
                  ? true
                  : false,
              errorMessage: "This field is required",
            }),
          },
        },
        {
          id: "cluster",
          label: "Cluster",
          placeholder: "Provide Cluster",
          type: "input",
          name: "cluster",
          disabled: () => true,
        },
      ],
    },
    {
      id: 4,
      title: "System Information",
      formStyle: {
        columnGap: "2.7%",
      },
      fieldStyle: {
        flex: "0 31.5%",
      },
      formFields: [
        {
          id: "created_by",
          label: "Created By",
          placeholder: "Provide Created By",
          type: "input",
          name: "created_by_name",
          disabled: () => true,
        },
        {
          id: "last_modified_by",
          label: "Last Modified By",
          placeholder: "Provide Last Modified By",
          type: "input",
          name: "last_modified_by_name",
          disabled: () => true,
        },
        {
          id: "created_date",
          label: "Created Date",
          placeholder: "Provide created date",
          type: "date",
          format: "DD-MMM-YYYY hh:mm a",
          name: "created_date",
          visible: () => true,
          disabled: () => true,
        },
        {
          id: "last_modified_date",
          label: "Last Modified Date",
          placeholder: "Provide last modified date",
          type: "date",
          name: "last_modified_date",
          format: "DD-MMM-YYYY hh:mm a",
          visible: () => true,
          disabled: () => true,
        },
        {
          id: "last_meaningful_activity_rh",
          label: "Last Meaningful Activity (RH)",
          placeholder: "Provide Last Meaningful Activity (RH)",
          type: "input",
          name: "last_meaningful_activity_rh",
          disabled: () => true,
        },
        {
          id: "duration_of_case_closed_first_time",
          label: "Duration Of Case Closed first time (BH)",
          placeholder: "Provide Duration Of Case Closed first time (BH)",
          type: "input",
          name: "duration_of_case_closed_first_time",
          disabled: () => true,
        },
        {
          id: "current_time_spent_open",
          label: "Current Time Spent Open (RH)",
          placeholder: "Provide Current Time Spent Open (RH)",
          type: "input",
          name: "current_time_spent_open",
          disabled: () => true,
        },
        {
          id: "time_with_current_owner",
          label: "Time With Current Owner (RH)",
          placeholder: "Provide Time With Current Owner (RH)",
          type: "input",
          name: "time_with_current_owner",
          disabled: () => true,
        },
        {
          id: "overall_age",
          label: "Overall Age (RH)",
          placeholder: "Provide Overall Age (RH)",
          type: "input",
          name: "overall_age",
          disabled: () => true,
        },
      ],
    },
  ];
};

const resolverDeptCollaborationReasonMapping = {
  "Ocean: Customer Service": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Cargo Readiness",
      label: "Cargo Readiness",
      value: "Cargo Readiness",
    },
    {
      id: 2,
      displayName: "COD, DIT, RIT and Re-Export",
      label: "COD, DIT, RIT and Re-Export",
      value: "COD, DIT, RIT and Re-Export",
    },
    {
      id: 3,
      displayName: "Cold Treatment",
      label: "Cold Treatment",
      value: "Cold Treatment",
    },
    {
      id: 4,
      displayName: "Controlled Atmosphere",
      label: "Controlled Atmosphere",
      value: "Controlled Atmosphere",
    },
    {
      id: 5,
      displayName: "Cross Trade Related",
      label: "Cross Trade Related",
      value: "Cross Trade Related",
    },
    {
      id: 6,
      displayName: "Customs Related",
      label: "Customs Related",
      value: "Customs Related",
    },
    {
      id: 7,
      displayName: "Damaged Container",
      label: "Damaged Container",
      value: "Damaged Container",
    },
    {
      id: 8,
      displayName: "Damage Prevention",
      label: "Damage Prevention",
      value: "Damage Prevention",
    },
    {
      id: 9,
      displayName: "DG Screening",
      label: "DG Screening",
      value: "DG Screening",
    },
    {
      id: 10,
      displayName: "Earlier Booking Request",
      label: "Earlier Booking Request",
      value: "Earlier Booking Request",
    },
    {
      id: 11,
      displayName: "Longstanding",
      label: "Longstanding",
      value: "Longstanding",
    },
    {
      id: 12,
      displayName: "Notification of Transport Status",
      label: "Notification of Transport Status",
      value: "Notification of Transport Status",
    },
    {
      id: 13,
      displayName: "OBL Surrender Check",
      label: "OBL Surrender Check",
      value: "OBL Surrender Check",
    },
    {
      id: 14,
      displayName: "OD3CP Element Updates",
      label: "OD3CP Element Updates",
      value: "OD3CP Element Updates",
    },
    {
      id: 15,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
    {
      id: 16,
      displayName: "Query Related to Claim",
      label: "Query Related to Claim",
      value: "Query Related to Claim",
    },
    {
      id: 17,
      displayName: "RCM Commercial Product",
      label: "RCM Commercial Product",
      value: "RCM Commercial Product",
    },
    {
      id: 18,
      displayName: "RKEM / GCSS Equipment Issue",
      label: "RKEM / GCSS Equipment Issue",
      value: "RKEM / GCSS Equipment Issue",
    },
    {
      id: 19,
      displayName: "Set Point",
      label: "Set Point",
      value: "Set Point",
    },
    {
      id: 20,
      displayName: "Split Shipment Task",
      label: "Split Shipment Task",
      value: "Split Shipment Task",
    },
    {
      id: 21,
      displayName: "Weight Discrepancy",
      label: "Weight Discrepancy",
      value: "Weight Discrepancy",
    },
  ],
  "Ocean: Customer Service - Export Doc": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Amendment",
      label: "Amendment",
      value: "Amendment",
    },
    {
      id: 2,
      displayName: "Certificate",
      label: "Certificate",
      value: "Certificate",
    },
    {
      id: 3,
      displayName: "Freetime",
      label: "Freetime",
      value: "Freetime",
    },
    {
      id: 4,
      displayName: "House Bill Request",
      label: "House Bill Request",
      value: "House Bill Request",
    },
    {
      id: 5,
      displayName: "Issuance",
      label: "Issuance",
      value: "Issuance",
    },
    {
      id: 6,
      displayName: "Pre Invoice - Payer Amendment",
      label: "Pre Invoice - Payer Amendment",
      value: "Pre Invoice - Payer Amendment",
    },
    {
      id: 7,
      displayName: "Split or Combine Request",
      label: "Split or Combine Request",
      value: "Split or Combine Request",
    },
    {
      id: 8,
      displayName: "Verify Copy",
      label: "Verify Copy",
      value: "Verify Copy",
    },
  ],
  "Ocean: Customer Service - Import Doc": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Arrival Notice",
      label: "Arrival Notice",
      value: "Arrival Notice",
    },
    {
      id: 2,
      displayName: "Customs Manifest",
      label: "Customs Manifest",
      value: "Customs Manifest",
    },
    {
      id: 3,
      displayName: "Delivery Order Release",
      label: "Delivery Order Release",
      value: "Delivery Order Release",
    },
    {
      id: 4,
      displayName: "Detention and Demurrage Inquiries",
      label: "Detention and Demurrage Inquiries",
      value: "Detention and Demurrage Inquiries",
    },
    {
      id: 5,
      displayName: "Invoice Inquiries",
      label: "Invoice Inquiries",
      value: "Invoice Inquiries",
    },
  ],
  "Ocean: Customer Service - SEM (Task Closure)": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Apply and Verify Price",
      label: "Apply and Verify Price",
      value: "Apply and Verify Price",
    },
    {
      id: 2,
      displayName: "Confirm Shipment",
      label: "Confirm Shipment",
      value: "Confirm Shipment",
    },
    {
      id: 3,
      displayName: "Mark Transport Document as Approved",
      label: "Mark Transport Document as Approved",
      value: "Mark Transport Document as Approved",
    },
    {
      id: 4,
      displayName: "Resolve Customs Data Quality Issues",
      label: "Resolve Customs Data Quality Issues",
      value: "Resolve Customs Data Quality Issues",
    },
    {
      id: 5,
      displayName: "Resolve Seal Mismatch",
      label: "Resolve Seal Mismatch",
      value: "Resolve Seal Mismatch",
    },
    {
      id: 6,
      displayName: "Send Prepaid Invoice Request",
      label: "Send Prepaid Invoice Request",
      value: "Send Prepaid Invoice Request",
    },
    {
      id: 7,
      displayName: "Specify Payment Terms",
      label: "Specify Payment Terms",
      value: "Specify Payment Terms",
    },
    {
      id: 8,
      displayName: "Specify Prepaid Invoice Details",
      label: "Specify Prepaid Invoice Details",
      value: "Specify Prepaid Invoice Details",
    },
  ],
  "Ocean: Finance - AFR Team": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "AFR Closure",
      label: "AFR Closure",
      value: "AFR Closure",
    },
  ],
  "Ocean: Legal": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Legal Support",
      label: "Legal Support",
      value: "Legal Support",
    },
    {
      id: 2,
      displayName: "Payment",
      label: "Payment",
      value: "Payment",
    },
    {
      id: 3,
      displayName: "Query Related to Claim",
      label: "Query Related to Claim",
      value: "Query Related to Claim",
    },
  ],
  "Ocean: Operations - Inland": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Booking Modification / Cancellation",
      label: "Booking Modification / Cancellation",
      value: "Booking Modification / Cancellation",
    },
    {
      id: 2,
      displayName: "Capacity Check",
      label: "Capacity Check",
      value: "Capacity Check",
    },
    {
      id: 3,
      displayName: "Delivery Order",
      label: "Delivery Order",
      value: "Delivery Order",
    },
    {
      id: 4,
      displayName: "Disputes",
      label: "Disputes",
      value: "Disputes",
    },
    {
      id: 5,
      displayName: "Diversion Action",
      label: "Diversion Action",
      value: "Diversion Action",
    },
    {
      id: 6,
      displayName: "Document Request",
      label: "Document Request",
      value: "Document Request",
    },
    {
      id: 7,
      displayName: "Load/Delivery Status",
      label: "Load/Delivery Status",
      value: "Load/Delivery Status",
    },
    {
      id: 8,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
    {
      id: 9,
      displayName: "Proactive Notification",
      label: "Proactive Notification",
      value: "Proactive Notification",
    },
    {
      id: 10,
      displayName: "Routing Request",
      label: "Routing Request",
      value: "Routing Request",
    },
    {
      id: 11,
      displayName: "Service Exception Notification",
      label: "Service Exception Notification",
      value: "Service Exception Notification",
    },
  ],
  "Ocean: Operations - Ocean": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Booking/Container Not In System",
      label: "Booking/Container Not In System",
      value: "Booking/Container Not In System",
    },
    {
      id: 2,
      displayName: "Claim Task/Query",
      label: "Claim Task/Query",
      value: "Claim Task/Query",
    },
    {
      id: 3,
      displayName: "Container Lost",
      label: "Container Lost",
      value: "Container Lost",
    },
    {
      id: 4,
      displayName: "Customs Related",
      label: "Customs Related",
      value: "Customs Related",
    },
    {
      id: 5,
      displayName: "Deadline Query/Mismatch",
      label: "Deadline Query/Mismatch",
      value: "Deadline Query/Mismatch",
    },
    {
      id: 6,
      displayName: "DG Chemical query",
      label: "DG Chemical query",
      value: "DG Chemical query",
    },
    {
      id: 7,
      displayName: "Incorrect Load / Discharge Move in RKEM",
      label: "Incorrect Load / Discharge Move in RKEM",
      value: "Incorrect Load / Discharge Move in RKEM",
    },
    {
      id: 8,
      displayName: "ITT/ETT Related",
      label: "ITT/ETT Related",
      value: "ITT/ETT Related",
    },
    {
      id: 9,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
    {
      id: 10,
      displayName: "RKEM / GCSS Equipment Issue",
      label: "RKEM / GCSS Equipment Issue",
      value: "RKEM / GCSS Equipment Issue",
    },
    {
      id: 11,
      displayName: "RKEM Dispute",
      label: "RKEM Dispute",
      value: "RKEM Dispute",
    },
    {
      id: 12,
      displayName: "RKEM Update",
      label: "RKEM Update",
      value: "RKEM Update",
    },
    {
      id: 13,
      displayName: "Seal Mismatch",
      label: "Seal Mismatch",
      value: "Seal Mismatch",
    },
    {
      id: 14,
      displayName: "Sharepoint Escalation",
      label: "Sharepoint Escalation",
      value: "Sharepoint Escalation",
    },
    {
      id: 15,
      displayName: "Short - Shipment Reason",
      label: "Short - Shipment Reason",
      value: "Short - Shipment Reason",
    },
    {
      id: 16,
      displayName: "Transport Plan Update",
      label: "Transport Plan Update",
      value: "Transport Plan Update",
    },
  ],
  "Ocean: Operations - Reefer": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Claims Analysis",
      label: "Claims Analysis",
      value: "Claims Analysis",
    },
    {
      id: 2,
      displayName: "Cold Treatment",
      label: "Cold Treatment",
      value: "Cold Treatment",
    },
    {
      id: 3,
      displayName: "Controlled Atmosphere",
      label: "Controlled Atmosphere",
      value: "Controlled Atmosphere",
    },
    {
      id: 4,
      displayName: "Datalog",
      label: "Datalog",
      value: "Datalog",
    },
    {
      id: 5,
      displayName: "Legal Query Related to Reefer",
      label: "Legal Query Related to Reefer",
      value: "Legal Query Related to Reefer",
    },
    {
      id: 6,
      displayName: "RCM Commercial Product",
      label: "RCM Commercial Product",
      value: "RCM Commercial Product",
    },
    {
      id: 7,
      displayName: "RCM Reefer",
      label: "RCM Reefer",
      value: "RCM Reefer",
    },
    {
      id: 8,
      displayName: "Set Point",
      label: "Set Point",
      value: "Set Point",
    },
  ],
  "Ocean: Sales": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Additional Freetime Request",
      label: "Additional Freetime Request",
      value: "Additional Freetime Request",
    },
    {
      id: 2,
      displayName: "Claim Task",
      label: "Claim Task",
      value: "Claim Task",
    },
    {
      id: 3,
      displayName: "COD Pricing Failure",
      label: "COD Pricing Failure",
      value: "COD Pricing Failure",
    },
    {
      id: 4,
      displayName: "Contract/Rate Validation",
      label: "Contract/Rate Validation",
      value: "Contract/Rate Validation",
    },
    {
      id: 5,
      displayName: "Credit Follow up",
      label: "Credit Follow up",
      value: "Credit Follow up",
    },
    {
      id: 6,
      displayName: "Detention and Demurrage Claims",
      label: "Detention and Demurrage Claims",
      value: "Detention and Demurrage Claims",
    },
    {
      id: 7,
      displayName: "Different / Changed Service Contract Number",
      label: "Different / Changed Service Contract Number",
      value: "Different / Changed Service Contract Number",
    },
    {
      id: 8,
      displayName: "Free time dispute",
      label: "Free time dispute",
      value: "Free time dispute",
    },
    {
      id: 9,
      displayName: "Incorrect Rates",
      label: "Incorrect Rates",
      value: "Incorrect Rates",
    },
    {
      id: 10,
      displayName: "In transit challenges / issues",
      label: "In transit challenges / issues",
      value: "In transit challenges / issues",
    },
    {
      id: 11,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
    {
      id: 12,
      displayName: "Rate / Invoice Dispute",
      label: "Rate / Invoice Dispute",
      value: "Rate / Invoice Dispute",
    },
    {
      id: 13,
      displayName: "Rates Not Available",
      label: "Rates Not Available",
      value: "Rates Not Available",
    },
    {
      id: 14,
      displayName: "Re-Import or Re-export Shipments",
      label: "Re-Import or Re-export Shipments",
      value: "Re-Import or Re-export Shipments",
    },
  ],
  "Ocean: Sales - DnD": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "DND Clarifications",
      label: "DND Clarifications",
      value: "DND Clarifications",
    },
    {
      id: 2,
      displayName: "Free days request/incorrect application",
      label: "Free days request/incorrect application",
      value: "Free days request/incorrect application",
    },
    {
      id: 3,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
  ],
  "MC CX: CHB": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
  ],
  "MC CX: Landside Transportation": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Booking Modification / Cancellation",
      label: "Booking Modification / Cancellation",
      value: "Booking Modification / Cancellation",
    },
    {
      id: 2,
      displayName: "Capacity Check",
      label: "Capacity Check",
      value: "Capacity Check",
    },
    {
      id: 3,
      displayName: "Delivery Order",
      label: "Delivery Order",
      value: "Delivery Order",
    },
    {
      id: 4,
      displayName: "Disputes",
      label: "Disputes",
      value: "Disputes",
    },
    {
      id: 5,
      displayName: "Diversion Action",
      label: "Diversion Action",
      value: "Diversion Action",
    },
    {
      id: 6,
      displayName: "Document Request",
      label: "Document Request",
      value: "Document Request",
    },
    {
      id: 7,
      displayName: "Load/Delivery Status",
      label: "Load/Delivery Status",
      value: "Load/Delivery Status",
    },
    {
      id: 8,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
    {
      id: 9,
      displayName: "Proactive Notification",
      label: "Proactive Notification",
      value: "Proactive Notification",
    },
    {
      id: 10,
      displayName: "Routing Request",
      label: "Routing Request",
      value: "Routing Request",
    },
    {
      id: 11,
      displayName: "Service Exception Notification",
      label: "Service Exception Notification",
      value: "Service Exception Notification",
    },
  ],
  "MC CX: LCL": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
  ],
  "MC Execution: CHB": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
  ],
  "MC Execution: Landside Transportation": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Booking Modification / Cancellation",
      label: "Booking Modification / Cancellation",
      value: "Booking Modification / Cancellation",
    },
    {
      id: 2,
      displayName: "Capacity Check",
      label: "Capacity Check",
      value: "Capacity Check",
    },
    {
      id: 3,
      displayName: "Delivery Order",
      label: "Delivery Order",
      value: "Delivery Order",
    },
    {
      id: 4,
      displayName: "Disputes",
      label: "Disputes",
      value: "Disputes",
    },
    {
      id: 5,
      displayName: "Diversion Action",
      label: "Diversion Action",
      value: "Diversion Action",
    },
    {
      id: 6,
      displayName: "Document Request",
      label: "Document Request",
      value: "Document Request",
    },
    {
      id: 7,
      displayName: "Load/Delivery Status",
      label: "Load/Delivery Status",
      value: "Load/Delivery Status",
    },
    {
      id: 8,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
    {
      id: 9,
      displayName: "Proactive Notification",
      label: "Proactive Notification",
      value: "Proactive Notification",
    },
    {
      id: 10,
      displayName: "Routing Request",
      label: "Routing Request",
      value: "Routing Request",
    },
    {
      id: 11,
      displayName: "Service Exception Notification",
      label: "Service Exception Notification",
      value: "Service Exception Notification",
    },
  ],
  "MC Execution: LCL": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Other",
      label: "Other",
      value: "Other",
    },
  ],
  "MC: Legal": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Legal Support",
      label: "Legal Support",
      value: "Legal Support",
    },
    {
      id: 2,
      displayName: "Payment",
      label: "Payment",
      value: "Payment",
    },
    {
      id: 3,
      displayName: "Query Related to Claim",
      label: "Query Related to Claim",
      value: "Query Related to Claim",
    },
  ],
  "SCM: Customer Service": [
    {
      id: 0,
      displayName: "Select",
      label: "Select",
      value: "",
    },
    {
      id: 1,
      displayName: "Book Barge",
      label: "Book Barge",
      value: "Book Barge",
    },
    {
      id: 2,
      displayName: "Book Rail",
      label: "Book Rail",
      value: "Book Rail",
    },
    {
      id: 3,
      displayName: "Book Space with Carrier",
      label: "Book Space with Carrier",
      value: "Book Space with Carrier",
    },
    {
      id: 4,
      displayName: "Book Truck",
      label: "Book Truck",
      value: "Book Truck",
    },
    {
      id: 5,
      displayName: "Carrier Booking Amendment",
      label: "Carrier Booking Amendment",
      value: "Carrier Booking Amendment",
    },
    {
      id: 6,
      displayName: "Carrier Forecast and Planning",
      label: "Carrier Forecast and Planning",
      value: "Carrier Forecast and Planning",
    },
    {
      id: 7,
      displayName: "Container Tracking",
      label: "Container Tracking",
      value: "Container Tracking",
    },
    {
      id: 8,
      displayName: "Document Dispatch to External Party",
      label: "Document Dispatch to External Party",
      value: "Document Dispatch to External Party",
    },
    {
      id: 9,
      displayName: "File Customs",
      label: "File Customs",
      value: "File Customs",
    },
    {
      id: 10,
      displayName: "New Client/Vendor Onboarding",
      label: "New Client/Vendor Onboarding",
      value: "New Client/Vendor Onboarding",
    },
    {
      id: 11,
      displayName: "Shipment Planning",
      label: "Shipment Planning",
      value: "Shipment Planning",
    },
  ],
};

export const emailStatusMapping = {
  0: "New",
  1: "Read",
  2: "Replied",
  3: "Sent",
  4: "Forwarded",
  5: "Draft",
};
